import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router";

const Home = lazy(() => import("@/app/Home"));
const Admin = lazy(() => import("@/app/Admin"));
const NotFound = lazy(() => import("@/app/NotFound"));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />}></Route>
          <Route path="/admin" element={<Admin />}></Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  </StrictMode>
);
